import type { FC, SVGProps } from "react";

const IconBeachIncluded: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1 2C1.6 2.5 2.2 3 3.5 3C6 3 6 1 8.5 1C11.1 1 10.9 3 13.5 3C16 3 16 1 18.5 1C19.8 1 20.4 1.5 21 2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 8C1.6 8.5 2.2 9 3.5 9C6 9 6 7 8.5 7C11.1 7 10.9 9 13.5 9C16 9 16 7 18.5 7C19.8 7 20.4 7.5 21 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 14C1.6 14.5 2.2 15 3.5 15C6 15 6 13 8.5 13C11.1 13 10.9 15 13.5 15C16 15 16 13 18.5 13C19.8 13 20.4 13.5 21 14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconBeachIncluded;
